import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import topdev from "assets/img/topdev.jpg";

import first from "assets/img/faces/first.png";
import second from "assets/img/faces/second.png";
import third from "assets/img/faces/third.png";
import other from "assets/img/faces/winner.png";
import validate from "assets/img/topdev-validate.jpg";


import styles from "assets/jss/material-kit-react/views/topdev.js";
import Axios from "axios";
import Config from "../../../config.js"
import swal from 'sweetalert'
import Ads from "../../Main/Sections/Ads5.js";
import { Helmet } from 'react-helmet'



const useStyles = makeStyles(styles);

export default function TopDevMainPage(props) {
    const classes = useStyles();
    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    var next = (register, challengeId) => {
        props.history.push("/TopDev/Enter/" + challengeId);
    }

    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Helmet>
                <title>کمپ آموزشی شریف | مسابقه برنامه نویسی topdev</title>
                <meta name="description" content="مسابقه الگوریتمی آنلاین و حضوری topdev با هدف یافتن استعدادهای برنامه نویسی." />
                <meta name="" content="topdev, contest, programming,java,c#,csharp,cpp,c++,سی شارپ، برنامه نویسی، مسابقه برنامه نویسی" />
            </Helmet>
            <Parallax small filter image={require("assets/img/bg8.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>
                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={topdev} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>مسابقات برنامه نویسی آنلاین کمپ آموزشی شریف</h3>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <br />
                        <br />
                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div className={classes.name}>
                                        <div className={classes.description}>
                                            <p>رقابت های برنامه نویسی همواره یکی از عوامل مهم در رشد و تعالی استعداد برنامه نویسان در کل دنیا می باشد.</p>
                                            <p>در این راستا فرجاد سامانه شریف با برگزاری مسابقات برنامه نویسی در سطح کشور تلاش می کند تا بستری مناسب برای ارتقای دانش فنی، مهارت و خلاقیت برنامه نویسان ایرانی را فراهم آورد. این مسابقات بهترین فرصت برای افرادی است که می خواهند مهارت خود را در حوزه حل مسئله و طراحی الگوریتم بسنجند.</p>
                                            <p>چنین مسابقاتی علاوه بر محک توانمندی، امکان آموزش، رقابت سالم و جذاب، امکان معرفی افراد مستعد به شرکت ها را نیز فراهم می&zwnj;کند.</p>
                                            <p>افراد در این مسابقه با ساده ترین کدهای برنامه نویسی به بیش از 30 زبان برنامه نویسی مختلف توانایی حل مسئله خود را به چالش خواهند کشید. با توجه به اینکه سامانه داوری به سرعت کدها را بررسی کرده و امتیازات را ثبت میکند، شاهد یک رقابت جذاب بین افراد باهوش و با استعداد خواهیم بود.</p>
                                        </div>
                                    </div>
                                    <br/>
                                    <br/>
                                    <Button variant="outlined" color="secondary" href="/TopDev/Enter" disableElevation>
                                    ثبت نام و ورود به سامانه مسابقه
                                </Button>
                                </div>
                               
                            </GridItem>
                        </GridContainer>
                        
                            <Ads/>
                            <br />
                        
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2 className={classes.h2Main}>آشنایی بیشتر با TopDev</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>رویداد TopDev یک مسابقه برنامه نویسی است که در آن توانایی های برنامه نویسان بدون در نظر گرفتن زبان برنامه نویسی خاص مورد سنجش قرار می گیرد.</p>
                                    <p>کلیه علاقمندان به برنامه نویسی بدون هیچ محدودیتی می توانند در این مسابقه شرکت کنند، بدان معنا که &nbsp;برای استفاده از تکنولوژی ها و زبان&zwnj;های برنامه نویسی هیچ محدودیتی وجود ندارد و مخاطب این رويداد تمامی کسانی هستند که توانایی برنامه نویسی دارند. فقط کافیست به یک زبان برنامه نویسی تسلط داشته باشيد تا بتوانيد در اين مسابقات شركت كنيد.</p>
                                    <p>رویداد TopDev در دو مرحله برگزار خواهد شد &nbsp;که به صورت خلاصه به شرح زیر است:</p>
                                    <p>مرحله اول در راستای سنجش توانایی افراد و استعداد یابی برگزار می شود.</p>
                                    <p>در این مرحله شرکت کنندگان تعدادی سوال چالشی دریافت کرده و مدت زمان محدودی برای پاسخ به این سوالات دارند. افرادی که تعداد سوال بیشتری حل کردند با دریافت امتیازات بیشتر به مراحل بعدی راه پیدا می&zwnj;کنند. سوالات چالشی رویداد توسط کمیته فنی مسابقات طراحی می شوند.</p>
                                    <p>این کمیته که حدود دو هفته قبل از برگزاری رویداد تشکیل شده است شامل برخی از سرمایه گذاران، شرکت های بزرگ حوزه فناوری اطلاعات، چهره های موفق استارتاپی و افراد سرشناس در حوزه فناوری اطلاعات است. همین گروه وظیفه داوری و امتیاز دهی به شرکت کنندگان را بر عهده دارند.</p>
                                    <p>مرحله دوم مربوط به صحت سنجی و بررسی نهایی برنامه نویسان راه یافته به این مرحله می باشد.</p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2  className={classes.h2Main}>اهداف برگزاری</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <p>
                                        <ul className={classes.rightToLeft}>
                                            <li>
                                                ایجاد اشتغال برای برنامه نویسان مستعد، خالق، توانمند و با انگیزه
                                            </li>
                                            <li>
                                                امکان جذب نیروی انسانی متخصص برای شرکت های فعال در حوزه فناوری اطلاعات
                                            </li>
                                            <li>
                                                ایجاد فرصت لذت بردن در فرآیندی با ترکیبی جذاب از آموزش، حل مسئله و خلاقیت
                                            </li>
                                            <li>
                                                لذت حل مساله به شیوه های گوناگون در فرآیندی خلاقانه
                                            </li>
                                            <li>
                                                ایجاد سرگرمی‌های علمی آموزشی
                                            </li>
                                            <li>
                                                ایجاد خودباوری و اعتماد به نفس در دانشجویان
                                            </li>
                                            <li>
                                                توجه به رغبت ها و علایق متفاوت دانشجویان
                                            </li>
                                            <li>
                                                شناسایی توانمندی ها و هدایت استعدادها در حوزه برنامه نویسی
                                            </li>
                                            <li>
                                                تشویق استعدادهای برتر و ایجاد انگیزه
                                            </li>
                                        </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>



                        <GridContainer justify='center' className={classes.box} id="prize">
                            <GridItem xs={12} sm={12} md={12}>
                                <h2  className={classes.h2Main}>جوایز نفرات برتر</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <br />
                            </GridItem>
                            <GridItem xs={6} sm={3} md={4}>
                                
                                <div className={classes.center}>
                                    <img
                                        src={first}
                                        alt="..."
                                        className={classes.imgRounded + " " + classes.imgFluid + " " + classes.image}
                                    />
                                </div>
                                <div>
                                    <h4 className={classes.center}>نفر اول (مدال طلا)</h4>
                                    <p className={classes.justify}>
                                        80 میلیون ریال + جوایز غیر نقدی + امکان استخدام در شرکت های معتبر فناوری اطلاعات
                                    </p>
                                </div>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={4}>
                                <div className={classes.center}>
                                    <img
                                        src={second}
                                        alt="..."
                                        className={classes.imgRounded + " " + classes.imgFluid + " " + classes.image}
                                    />
                                </div>
                                <div>
                                    <h4 className={classes.center}>نفر دوم (مدال نقره)</h4>
                                    <p className={classes.justify}>
                                        50 میلیون ریال+ جوایز غیر نقدی + امکان استخدام در شرکت های معتبر فناوری اطلاعات
                                    </p>
                                </div>
                            </GridItem>
                            <GridItem xs={6} sm={3} md={4}>
                                <div className={classes.center}>
                                    <img
                                        src={third}
                                        alt="..."
                                        className={classes.imgRounded + " " + classes.imgFluid + " " + classes.image}
                                    />
                                </div>
                                <div>
                                    <h4 className={classes.center}>نفر سوم (مدال برنز)</h4>
                                    <p className={classes.justify}>
                                        30 میلیون ریال+ جوایز غیر نقدی + امکان استخدام در شرکت های معتبر فناوری اطلاعات
                                    </p>
                                </div>
                            </GridItem>
                        {/*     <GridItem xs={6} sm={3} md={3}>
                                <div className={classes.center}>
                                    <img
                                        src={other}
                                        alt="..."
                                        className={classes.imgRounded + " " + classes.imgFluid + " " + classes.image}
                                    />
                                </div>
                                <div>
                                    <h4 className={classes.center}>نفرات چهارم</h4>
                                    <p className={classes.justify}>
                                        کارت هدیه ریالی + امکان استخدام در شرکت های معتبر فناوری اطلاعات
                                    </p>
                                </div>
                            </GridItem>
                            */}
                        </GridContainer>


                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2  className={classes.h2Main}>روند برگزاری</h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <h3  className={classes.sub}>ثبت نام و دست گرمی</h3>
                                    <p>
                                        اگر تمایل به حضور و شرکت در مراحل بعدی مسابقه را دارید، جهت ثبت نام لازم است ابتدا در همین سایت عضو شده، سپس وارد بخش مسابقه شوید.
                                        <br />
                                        ارسال پاسخ هر کدام از سوال ها به منزله ثبت نام در مسابقه و جواز شرکت در مراحل بعد خواهد بود.
                                    </p>
                                </div>
                                <br />
                                <div className={classes.description}>
                                    <h3  className={classes.sub}>مقدماتی</h3>
                                    <p>افتتاحیه مسابقات راس ساعت ۹:00 صبح &nbsp;آغاز خواهد شد.</p>
                                    <p>سپس مرحله مقدماتی مسابقه ساعت 11:00 صبح شروع شده و تا ساعت 11:00 صبح روز بعد (24 ساعت) ادامه خواهد داشت.</p>
                                    <p>ثبت نام به صورت انفرادی و رایگان می باشد و محدودیتی در سن و سال، مقطع تحصیلی، رشته تحصیلی و محل سکونت و ... ندارد و برای عموم آزاد است.&nbsp;</p>
                                    <p>تنها مسئله مهم این است که شرکت کنندگان با یک زبان برنامه نویسی آشنایی داشته باشند و با استفاده از زبان برنامه نویسی که انتخاب خواهند کرد پاسخ مناسب برای چالش های مسابقات را ارسال نمایند.</p>
                                    <p>در این مرحله شرکت کنندگان حدود 8 الی 10 سوال آسان تا سخت دریافت می کنند و 24 ساعت فرصت دارند تا پاسخ چالش ها را در سامانه مسابقات ثبت کرده و نمره مربوطه را دریافت نمایند.</p>
                                    <p>شرکت کنندگان در هر لحظه از مسابقه می توانند جدول رتبه بندی را به صورت زنده مشاهده کنند. توجه بفرمایید که فقط نفرات برتر که بیشترین امتیاز را دریافت کردند مجوز ورود به مرحله نهایی مسابقات را خواهند داشت. سوالات این مرحله در کمیته ارتباط با صنعت رویداد طراحی خواهد شد و در کل مدت این مرحله طراحان سوالات، گروه مشاورین و داوران مسابقات به صورت آنلاین پاسخگوی سوالات شرکت کنندگان خواهند بود .</p>
                                </div>
                                <br />
                                <div className={classes.description}>
                                    <h3  className={classes.sub}>مرحله نهایی</h3>
                                    <p>مرحله نهایی مسابقه ساعت 09:00 صبح شروع شده و تا ساعت 09:00 صبح روز بعد (24 ساعت) ادامه خواهد داشت.</p>
                                    <p>در این مرحله شرکت کنندگان حدود 8 الی 10 سوال متوسط تا سخت دریافت خواهند کرد و 24 ساعت فرصت دارند تا پاسخ چالش ها را در سامانه مسابقات ثبت کرده و نمره مربوطه را دریافت نمایند. سوالات این مرحله سخت تر و شرکت کنندگان تنها از نفرات برتر مرحله قبلی خواهند بود.</p>
                                    <p>شرکت کنندگان در هر لحظه از مسابقه می توانند جدول رتبه بندی را به صورت زنده مشاهده کنند . همچون مرحله قبل سوالات در کمیته ارتباط با صنعت رویداد طراحی خواهد شد و در کل مدت این مرحله طراحان سوالات، گروه مشاورین و داوران مسابقات به صورت آنلاین پاسخگوی سوالات شرکت کنندگان خواهند بود .</p>
                                </div>
                                <br />
                                <div className={classes.description}>
                                    <h3  className={classes.sub}>مرحله صحت سنجی</h3>
                                    <p>در مرحله نهایی فقط افرادی که در مرحله قبل حد نصاب نمره را دریافت کردند و در لیست نفرات برتر مسابقات بودند اجازه ورود به مرحله نهایی مسابقه را خواهند داشت.</p>
                                    <p>مرحله صحت سنجی مسابقه به جهت بررسی برنامه نویسان و جلوگیری از تقلب، بلافاصله پس از اتمام مرحله نهایی برگزار می شود.</p>
                                    <p>این مرحله راس ساعت 11:30 دقیقه صبح آغاز خواهد شد و ساعت 17:00 همان روز به پایان خواهد رسید . این افراد می بایست در سالن کنفرانس به صورت حضوری یا آنلاین حاضر شوند و به صورت شفاهی به سوالات داوران و کمیته فنی پاسخ دهند. در این مرحله گروهی از متخصصان و نمایندگان شرکت&zwnj;های بزرگ حوزه فناوری اطلاعات به عنوان تیم داوری مرحله صحت سنجی حضور خواهند داشت.&nbsp;</p>
                                    <p>سپس بر اساس ترتیب از قبل اعلام شده تک تک افراد راه یافته به مرحله نهایی به صورت انفرادی وارد ویدئو کنفرانس شده و به مدت 10 دقیقه به سوالات تیم داوری پاسخ خواهند داد و نمره مربوط به این بخش را دریافت خواهند نمود. سوالات داوران در راستای بررسی پاسخ های ارسالی افراد در مراحل قبل خواهد بود. در این مدت سایر شرکت کنندگان که هنوز نوبت ارائه آنها نشده است می توانند به صورت زنده جلسه پرسش و پاسخ افراد دیگر را مشاهده کنند.</p>
                                    <p>البته سایر شرکت کنندگان که از دور مسابقات حذف شدند و کلیه علاقه&zwnj;مندان به مسابقه نیز به عنوان تماشاچی میتوانند اتفاقات این مرحله را به صورت زنده مشاهده کنند (بازدید این مرحله برای عموم آزاد است). &nbsp;پس از پایان مرحله صحت سنجی، داوران به مدت 30 دقیقه جهت انتخاب نفرات برتر وارد جلسه خواهند شد تا در مراسم اختتامیه افراد برتر را معرفی نمایند. اختتامیه مسابقات راس ساعت 17:00 &nbsp;آغاز خواهد شد.</p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h2  className={classes.h2Main}>مزایای شرکت در این مسابقه برای شرگت کنندگان </h2>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        <ul>
                                            <li>حضور در یک محیط جدی و واقعی جهت سنجش توانایی های فردی</li>
                                            <li>به روز رسانی اطلاعات و دانش فنی افراد در حین مواجهه با چالش‌های روز دنیای فناوری اطلاعات</li>
                                            <li>آشنایی با نقاط ضعف و قوت شخصی در مواجهه با چالش های واقعی</li>
                                            <li>آشنایی و آموزش مباحث جدید که تا به حال با آن رو به رو نشده ایم</li>
                                            <li>بر قراری ارتباط با افراد مجرب و حرفه ای که در حین مسابقه به عنوان داور و مشاور در کنار شرکت کنندگان هستند</li>
                                            <li>ارتباط با مدیران شرکت های بزرگ حوزه فناوری اطلاعات که به عنوان مشاور در حین مسابقه در کنار شرکت کنندگان هستند</li>
                                            <li>امکان مصاحبه و استخدام در شرکت های بزرگ فناوری اطلاعات</li>
                                            <li>امکان معرفی شرکت کنندگان در مسابقات به شتابدهنده ها و مراکز رشد</li>
                                            <li>دریافت جوایز نقدی و غیر نقدی</li>
                                            <li>عضویت در خانواده کمپ آموزشی شریف  و استفاده از امکانات این سامانه</li>
                                        </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
